var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"tour-intro-component","pa-0":""}},[_c('v-img',{attrs:{"src":_vm.step.url.url,"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }